// UrlInputStep.tsx — step 'url-input' del onboarding.
// Qué hace: pide la URL del sitio y dispara el scan; valida formato de URL en vivo.
// Qué exporta: UrlInputStep.
// Quién lo usa: CreateWorkspaceModal.

import { Button } from '../../Button';
import { UrlRow, UrlInput, isValidUrl } from '../styled';

interface Props {
  url: string;
  setUrl: (v: string) => void;
  handleScan: () => void;
}

export function UrlInputStep({ url, setUrl, handleScan }: Props) {
  return (
    <>
      <UrlRow>
        <UrlInput
          value={url}
          onChange={e => setUrl(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter' && isValidUrl(url)) { e.preventDefault(); handleScan(); } }}
          placeholder="https://yourbrand.com"
          autoFocus
        />
        <Button type="button" onClick={handleScan} disabled={!isValidUrl(url)} $size="sm">Scan</Button>
      </UrlRow>
      <div style={{ fontSize: 11, color: url.trim() && !isValidUrl(url) ? '#dc2626' : '#94a3b8', marginTop: 6 }}>
        {url.trim() && !isValidUrl(url)
          ? 'Enter a valid URL, e.g., https://yourbrand.com'
          : 'Paste your full site URL (with https://).'}
      </div>
    </>
  );
}
